import { render, staticRenderFns } from "./pagenation.vue?vue&type=template&id=4d79ec40"
import script from "./pagenation.vue?vue&type=script&lang=js"
export * from "./pagenation.vue?vue&type=script&lang=js"
import style0 from "./pagenation.vue?vue&type=style&index=0&id=4d79ec40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports